import { trackEvent } from './trackEvent';

export function trackClicked(
  name: string,
  properties: Record<string, unknown> = {},
) {
  trackEvent(`Clicked: ${name}`, properties);
}
